<template>
  <v-container fluid clas vscs-container>
    <v-layout wrap>
      <v-flex v-show="item.visible" :class="grid" class="vscs-flex" v-for="(item, i) in theItems" :key="i" @click="onClickCard(item, i)">
        <v-card color="white" class="vscs-card" hover>
          <v-card-media>
            <v-layout row wrap>
              <v-flex xs4>
                <div class="vscs-card-icon" :style="{ backgroundColor: item.color }">
                 <v-layout class="vscs-icon" justify-space-around>
                  <v-icon :color="item.iconColor">{{ item.icon }}</v-icon>
                </v-layout>
                </div>
              </v-flex>
              <v-flex xs8>
                <v-card>
                  <v-card-title class="vscs-card-title" primary-title>
                    <div>
                      <p>{{ item.title || item.text }}<br>
                        <span class="vscs-card-value">{{ item.value }}</span></p>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-media>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

'use strict'

export default {

  name: 'VuetifyStatsCards',

  props:
  {
    items: {
      type: Array,
      default: () => [],
      required: true
    },
    grid: {
      type: String,
      default: 'xs12 sm6 md4'
    }
  },

  data () {
    return {
      theItems: []
    }
  },

  mounted () {
    this.theItems = this.items
  },

  methods:
  {
    onClickCard (item, index) {
      this.$emit('on-click-card', item, index)
    }
  },

  watch: {
    'items' (val) {
      this.theItems = val
    }
  }
}
</script>

<style lang="sass">
.vscs-card
  max-height: 83px
  margin-bottom: 0px

.vscs-card-title
  color: #999999
  margin-top: -14px
  float: right
  text-overflow: initial
  font-size: 1em
  margin-bottom: 0
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis

.vscs-card-value
  color: rgba(0, 0, 0, 0.87)
  float: right
  font-size: 1.625em
  font-weight: 300
  line-height: 1.5em

.vscs-card-icon
  width: 83px !important
  height: 83px !important
  display: flex
  border-radius: 2px
  background-color: rgb(96, 125, 139)

.vscs-icon > i
  font-size: 40px

.vscs-container
  padding: 12px

.vscs-flex
  padding: 12px

.vscs-divider
  margin: 0 auto
  width: 95%
</style>



// WEBPACK FOOTER //
// src/components/vuetify-stats-cards.vue